import { render, staticRenderFns } from "./ReadNews.vue?vue&type=template&id=028f4c48&scoped=true"
import script from "./ReadNews.vue?vue&type=script&lang=js"
export * from "./ReadNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f4c48",
  null
  
)

export default component.exports